import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import RecoleccionesMes from "../components/punto_generacion/recolecciones_mes.jsx";
import NfuReportadosVSEntregados from "../components/punto_generacion/nfu_reportados_vs_entregados";
import NfuEntregadosPorTipo from "../components/punto_generacion/nfu_entregados_por_tipo";
import NfuEntregadosPorMesyPorTipo from "../components/punto_generacion/nfu_entregados_mes_y_por_tipo";
import useNfus from "../hooks/punto_generacion/nfus.js";
import '../styles/graficas.css';

const Dashboard = () => {
  const [year, setYear] = useState("acumulado");
  const [token, setToken] = useState(null);
  const [idPuntoGeneracion, setIdPuntoGeneracion] = useState(null); 
  const location = useLocation();

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 2018 + 1 }, (_, i) => currentYear - i);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tokenFromUrl = params.get("token");
    const idFromUrl = params.get("idPuntoGeneracion");

    if (tokenFromUrl) {
      setToken(tokenFromUrl);
    }
    if (idFromUrl) {
      setIdPuntoGeneracion(parseInt(idFromUrl, 10)); 
    }
  }, [location.search]);

  const datosNfus = useNfus(year, token, idPuntoGeneracion); 

  const datos = Array.isArray(datosNfus) && datosNfus.length > 0 ? datosNfus[0] : {};
  const totalNfuEntregados = datos.cantidad_entregada || 0;
  const pesoTotal = datos.Peso || 0;
  const solicitudesRealizadas = datos.Solicitudes || 0;

  return (
    <div className="dashboard-container">
      <div className="year-selector">
        <label>Año:</label>
        <select
          value={year}
          onChange={(e) => setYear(e.target.value === "acumulado" ? "acumulado" : parseInt(e.target.value))}
        >
          <option value="acumulado">Acumulado</option>
          {years.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>

      <div className="container-cantidades">
        <div className="nfu">
          <img src="/assets/icono_llanta.jfif" className="icono-nfu" />
          <div className="peso">
            <label className="nombre">Nfu Entregados</label>
            <label className="numeros">{totalNfuEntregados}</label>
          </div>
        </div>

        <div className="linea-vertical"></div>

        <div className="nfu">
          <img src="/assets/icono_llanta.jfif" className="icono-nfu" />
          <div className="peso">
            <label className="nombre">Peso (kg)</label>
            <label className="numeros">{pesoTotal}</label>
          </div>
        </div>
      </div>

      <div className="container-cantidades">
        <div className="nfu">
          <img src="/assets/solicitud.png" className="icono-nfu1" />
          <div>
            <label className="nombre">Solicitudes realizadas:</label>
            <label className="numeros" id="solicitud">{solicitudesRealizadas}</label>
          </div>
        </div>
      </div>

      <div className="container-graficas">
        <RecoleccionesMes year={year} token={token} idPuntoGeneracion={idPuntoGeneracion} />
        <NfuReportadosVSEntregados year={year} token={token} idPuntoGeneracion={idPuntoGeneracion} />
        <NfuEntregadosPorTipo year={year} token={token} idPuntoGeneracion={idPuntoGeneracion} />
        <NfuEntregadosPorMesyPorTipo year={year} token={token} idPuntoGeneracion={idPuntoGeneracion} />
      </div>
    </div>
  );
};

export default Dashboard;